module.exports = __webpack_public_path__ + "pcstatic/img/book2.9e8f459.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/book2.png
// module id = Zi0h
// module chunks = 34